var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemoveImg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1377_19402)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6.29883,
    r: 6,
    fill: "#F36960"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99531 10.598C3.62331 10.598 1.69531 8.67005 1.69531 6.29805C1.69531 3.92605 3.62331 1.99805 5.99531 1.99805C8.36731 1.99805 10.2953 3.92605 10.2953 6.29805C10.2953 8.67005 8.36731 10.598 5.99531 10.598ZM5.99531 2.59805C3.95531 2.59805 2.29531 4.25805 2.29531 6.29805C2.29531 8.33805 3.95531 9.99805 5.99531 9.99805C8.03531 9.99805 9.69531 8.33805 9.69531 6.29805C9.69531 4.25805 8.03531 2.59805 5.99531 2.59805Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.86541 7.73019C4.78941 7.73019 4.71341 7.70219 4.65341 7.64219C4.53741 7.52619 4.53741 7.33419 4.65341 7.21819L6.91741 4.95419C7.03341 4.83819 7.22541 4.83819 7.34141 4.95419C7.45741 5.07019 7.45741 5.26219 7.34141 5.37819L5.07741 7.64219C5.02141 7.70219 4.94141 7.73019 4.86541 7.73019Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.12941 7.73019C7.05341 7.73019 6.97741 7.70219 6.91741 7.64219L4.65341 5.37819C4.53741 5.26219 4.53741 5.07019 4.65341 4.95419C4.76941 4.83819 4.96141 4.83819 5.07741 4.95419L7.34141 7.21819C7.45741 7.33419 7.45741 7.52619 7.34141 7.64219C7.28141 7.70219 7.20541 7.73019 7.12941 7.73019Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1377_19402"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0 0.298828)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveImg);
export default __webpack_public_path__ + "static/media/removeImg.c071d233cc1b38e62b8292eff72cd08a.svg";
export { ForwardRef as ReactComponent };